import { Grid } from "@mui/material";
import { AppProgressCard } from "components/progress-card.component";
import { AppStatisticsCard } from "components/statistics-card.component";

export function AppStatisticsInfo({ pageData, fullInfoIb, ibSalesCounter }) {
  console.log(fullInfoIb);
  const progressInfo = pageData.progress.map((item) => {
    if (item.key === "points" && fullInfoIb) {
      return {
        ...item,
        value: `${fullInfoIb.ibPoints} ${item.value}`,
        legend: {
          ...item.legend,
          initial: `${fullInfoIb.ibPoints} ${item.legend.initial}`,
          final: `${fullInfoIb.ibNextLevelGoal} ${item.legend.final}`,
        },
        progress: (fullInfoIb.ibPoints / fullInfoIb.ibNextLevelGoal) * 100,
      };
    }
    return item;
  });
  const staticsInfo = pageData.statistics.map((item) => {
    if (item.key === "currentLevel" && fullInfoIb) {
      const level = `${fullInfoIb.ibTypeLabel} ${fullInfoIb.ibLevel}`;
      return { ...item, value: level ?? "- - -" };
    }
    if (item.key === "repeats" && fullInfoIb) {
      return {
        ...item,
        value: `${fullInfoIb.ibChallengeRepeats ?? 0} ${item.value}`,
        show: !fullInfoIb.isIPF,
      };
    }
    // if (item.key === "totalCommissions" && fullInfoIb) {
    //   return {
    //     ...item,
    //     value: `${new Intl.NumberFormat("en-US", {
    //       currency: "USD",
    //       style: "currency",
    //       maximumFractionDigits: 2,
    //     }).format(fullInfoIb.totalCommissions ?? 0)} ${item.value}`,
    //   };
    // }
    if (item.key === "capital" && fullInfoIb) {
      return {
        ...item,
        value: `${new Intl.NumberFormat("en-US", {
          currency: "USD",
          style: "currency",
          maximumFractionDigits: 0,
        }).format(fullInfoIb.ibCapital ?? 0)} ${item.value}`,
        show: !fullInfoIb.isIPF,
      };
    }
    if (item.key === "clicks" && fullInfoIb) {
      return { ...item, value: `${fullInfoIb.ibClicks ?? 0} ${item.value}` };
    }
    if (item.key === "sales" && fullInfoIb) {
      return { ...item, value: ibSalesCounter };
    }
    if (item.key === "totalRecords" && fullInfoIb) {
      return { ...item, value: fullInfoIb.registers };
    }
    if (item.key === "salesCount" && fullInfoIb) {
      return { ...item, value: fullInfoIb.salesCount ?? 0 };
    }
    if (item.key === "conversionRate" && fullInfoIb) {
      const clicks = fullInfoIb.ibClicks ?? 0;
      const convertionRate = ((ibSalesCounter / clicks) * 100).toFixed(2);
      return {
        ...item,
        value: (ibSalesCounter === 0 && clicks === 0 ? 0 : convertionRate) + item.value,
      };
    }
    if (item.key === "duration" && fullInfoIb && fullInfoIb.isIPF) {
      const endDate = new Date(fullInfoIb.ibCycleEnd);
      const currentDate = new Date();
      const dayDiff = (endDate.getTime() - currentDate.getTime()) / 86400000;
      return {
        ...item,
        value: `${Math.round(dayDiff)} ${dayDiff > 1 ? "días" : "día"}`,
      };
    }
    if (item.key === "totalSales" && fullInfoIb) {
      return {
        ...item,
        value: `${new Intl.NumberFormat("en-US", {
          currency: "USD",
          style: "currency",
          maximumFractionDigits: 0,
        }).format(fullInfoIb.totalSales ?? 0)} ${item.value}`,
        show: fullInfoIb.isIPF,
      };
    }
    if (item.key === "totalCommissions" && fullInfoIb) {
      return {
        ...item,
        value: `${new Intl.NumberFormat("en-US", {
          currency: "USD",
          style: "currency",
          maximumFractionDigits: 0,
        }).format(fullInfoIb.totalCommissions ?? 0)} ${item.value}`,
        show: fullInfoIb.isIPF,
      };
    }
    return item;
  });

  return (
    <Grid container spacing={2} marginTop={4}>
      {progressInfo.map(({ title, key, value, legend, progress }) => (
        <Grid item xs={6} xl={3} key={key}>
          <AppProgressCard
            title={{ text: title, fontWeight: "regular" }}
            count={value}
            legend={legend}
            progress={progress}
          />
        </Grid>
      ))}
      {staticsInfo
        .filter((item) => item.show)
        .map(({ title, value, key }) => (
          <Grid item xs={6} xl={3} key={key}>
            <AppStatisticsCard title={{ text: title, fontWeight: "regular" }} type={key} count={value} />
          </Grid>
        ))}
    </Grid>
  );
}
